import { Image } from '@storyofams/storyblok-toolkit';

import { Button } from '../Button';
import { Heading } from '../Heading';

export const OverviewHeader = ({ content }) => {
  return (
    <div className="w-full overflow-x-clip overflow-y-visible">
      <div className="w-full max-w-6xl px-4 mx-auto pt-16 pb-20 flex flex-col lg:flex-row lg:justify-between lg:items-center">
        <div className="md:max-w-[480px] relative z-10 mx-auto lg:mx-0 flex-1">
          {!!content?.kicker && (
            <Heading variant="h6" className="text-gray-600 mb-2 md:mb-6">
              {content?.kicker}
            </Heading>
          )}
          {!!content?.title && (
            <Heading variant="h3" as="h1">
              {content?.title}
            </Heading>
          )}
          {!!content?.subtitle && (
            <p className="mt-4 text-gray-700 w">{content?.subtitle}</p>
          )}
          {!!content?.button_text && (
            <Button
              variant="primary"
              className="w-full md:w-auto mt-10 md:mt-12"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();

                document
                  .querySelector('#webinars')
                  ?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              {content?.button_text}
            </Button>
          )}
        </div>

        <div className="flex-1 w-full md:max-w-[538px] mx-auto lg:mx-0 relative mt-12 lg:mt-0">
          {!!content?.image?.filename && (
            <div className="w-full rounded-2xl aspect-[343/300] md:aspect-[16/9] bg-grey-100 overflow-hidden relative z-10">
              <Image
                alt={content?.image?.alt || content?.title || ''}
                src={content?.image?.filename}
                fluid={532}
                fit="cover"
                showPlaceholder={false}
                height="100%"
                width="100%"
                className="rounded-2xl overflow-hidden"
              />
            </div>
          )}
          <div className="rounded-full w-[20%] aspect-[1/1] bg-yellow-500 absolute -top-8 -left-10 blur-2xl z-0" />
          <div className="rounded-full w-[60%] aspect-[1/1] bg-yellow-500/40 absolute top-16 -right-40 blur-3xl z-0" />
        </div>
      </div>
    </div>
  );
};
